export default "/_next/static/chunks/fonts/Montserrat-Regular-latin-7a6759d446b7b97ba9dcb39dcf584163.woff2";